
class CornerQuestions {
  private categoryButtons: NodeListOf<HTMLButtonElement>;
  constructor() {
    this.categoryButtons = document.querySelectorAll('.corner-questions__category[data-target]');
    if (this.categoryButtons.length > 0) {
      this._init();
    }
  }

  _init() {
    this.categoryButtons.forEach(button => {
      button.addEventListener('click', (event) => this.scrollToCategory(event));
    });
  }



  private scrollToCategory(event: MouseEvent): void {
    const button = event.currentTarget as HTMLButtonElement;
    const targetSelector = button.dataset.target;

    if (!targetSelector) return;

    const targetElement = document.querySelector<HTMLDivElement>(targetSelector);

    if (targetElement) {
      const header = document.querySelector<HTMLElement>('.header__row');
      let headerHeight = 0;

      if (header && window.innerWidth >= 767) {
        headerHeight = header.offsetHeight + 30;
      }

      const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;

      const offsetPosition = elementPosition - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }




}

export const cornerQuestions = new CornerQuestions();
